import { createSelector } from 'reselect'

import { ProfileReducer } from '../reducers/domain'

const isAllLocationValuesSet = (data: ProfileReducer['data']) =>
  !!data && !!data.longitude && !!data.latitude && !!data.location

const isAnyBudgetValuesSet = (data: ProfileReducer['data']) => !!data && !!data.budget

const isPhoneSet = ({ profile }: { profile: { data: ProfileReducer['data'] } }) =>
  !profile.data || !profile.data.phoneNumber ? ('Add your mobile number' as string) : false
const isLocationSet = ({ profile }: { profile: { data: ProfileReducer['data'] } }) =>
  !isAllLocationValuesSet(profile.data) ? 'Add your location' : false
const isBudgetSet = ({ profile }: { profile: ProfileReducer }) =>
  !isAnyBudgetValuesSet(profile.data) ? 'Set your budget' : false

export default createSelector(
  isPhoneSet,
  isLocationSet,
  isBudgetSet,
  (...suggestions) => suggestions.filter((suggestion: any) => !!suggestion) as any,
)
